import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { injectIntl } from 'gatsby-plugin-intl'
import { colors } from 'utils/utils'
import { IoIosArrowDown } from 'react-icons/io'
import Switch from "react-switch"

export default injectIntl(props => {
	const origSwitchClass = props.alwaysActive ? 'alwaysActive' : ''
	const [open, setOpen] = useState(false)
	const [checked, setChecked] = useState(false)
	const [switchClass, setSwitchClass] = useState(origSwitchClass)
	const [accordionClass, setAccordionClass] = useState('')
	const { title, hasSwitch, switchId, grayBackground } = props

	useEffect(() => {
		if(checked) {		
			setSwitchClass(switchClass => `${switchClass} checked`)
		} else {
			setSwitchClass(origSwitchClass)
		}
	}, [checked, origSwitchClass])

	useEffect(() => {
		setAccordionClass(grayBackground ? 'gray' : '')
	}, [grayBackground])

	useEffect(() => {
		setChecked(props.switchChecked ? props.switchChecked : false)
	}, [props.switchChecked])

	const toggleSwitch = () => {
		props.handleSwitchToggle(switchId, !checked)
	}

	const handleClick = () => {
		setOpen(open => !open)
	}
	
    return(
        <Accordion className={accordionClass}>
			<Header>
				<Button onClick={handleClick}>
					<IoIosArrowDown className={open ? 'open' : ''} />
					<Title>{title}</Title>
				</Button>
				{ hasSwitch && <SwitchButton 
					className={switchClass}
					disabled={props.alwaysActive ? true : false}
					checked={checked}
					onChange={toggleSwitch}
				/> }
			</Header>
			<Content className={open? 'open' : ''}>
				{ props.children }
			</Content>
        </Accordion>
    )
})

const Header = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`
	
const Button = styled.button`
	display: flex;
	flex-direction: row;
	width: 100%;
	border: 0;
	background-color: ${colors.tertiary};
	cursor: pointer;

	svg {
		width: 1rem;
		height: auto;
		align-self: center;
		margin: 0 1rem;
		transition: transform .3s ease-in-out;

		&.open {
			transform: rotate(-180deg);
		}
	}
`

const SwitchButton = styled(Switch)`
	align-self: center;
	margin: 0 1.5rem;

	&.alwaysActive {
		opacity: 0.2!important;
		filter: grayscale(1);
	}

	&.checked .react-switch-bg {
		background: ${colors.secondary}!important;
	}
`

const Title = styled.h4`
	width: 100%;
	font-weight: 700;
	text-align: left;
`

const Content = styled.div`
	height: auto;
	max-height: 0;
	overflow: hidden;
	transition: max-height .5s ease-in-out;
	line-height: 1.35;
	
	&.open {
		max-height: 2500px;
	}
`

const Accordion = styled.div`
	width: 100%;
	border: solid 1px ${colors.quinary};
	&:not(:last-of-type) {
		border-bottom: 0;
	}
	&.gray ${Content} {
		background-color: ${colors.quinary};
	}
`